import type { TFunction } from 'i18next';

/**
 * REV-795: display labels for VPAT conformance levels and evidence flags.
 *
 * The API sends both as snake_case values, and those stay the join key on the
 * wire. The words are the UI's, per locale, under `conformance.levels.*` and
 * `conformance.flags.*`. Before this, the audit review, criterion detail and
 * attestation screens each kept their own English map, out of a translator's
 * reach.
 */
export const CONFORMANCE_LEVELS = [
  'supports',
  'partially_supports',
  'does_not_support',
  'not_applicable',
  'not_evaluated',
] as const;

/** revenant-api CriterionRollupService.FLAGS. */
export const EVIDENCE_FLAGS = [
  'critical_path_failure',
  'coverage_below_threshold',
  'insufficient_evidence',
  'ambiguous',
  'single_method',
  'unconfirmed_evidence',
] as const;

/**
 * The label for a conformance level. A value with no label is shown as sent:
 * the API may learn a level before the UI does, and a raw value is better than
 * a blank chip.
 */
export function conformanceLevelLabel(t: TFunction, level: string): string {
  return (CONFORMANCE_LEVELS as readonly string[]).includes(level)
    ? t(`conformance.levels.${level}`, level)
    : level;
}

/** The label for an evidence flag, passing an unknown flag through as sent. */
export function evidenceFlagLabel(t: TFunction, flag: string): string {
  return (EVIDENCE_FLAGS as readonly string[]).includes(flag)
    ? t(`conformance.flags.${flag}`, flag)
    : flag;
}
